import { Routes } from '@angular/router';
import { AuthGuard } from '@app/shared/guards/auth.guard';
import { ForceChangePasswordGuard } from '@app/shared/guards/force-change-password.guard';

export const DASHBOARD_ROUTES: Routes = [
  {
    path: ':organizacao/dashboard',
    loadComponent: async () =>
      (await import('./dashboard.domain')).DashboardDomain,
    canActivateChild: [AuthGuard, ForceChangePasswordGuard],

    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'home',
      },
      {
        path: 'home',
        loadComponent: async () =>
          (await import('./pages/home/home.page')).HomePage,
        canActivate: [AuthGuard, ForceChangePasswordGuard],
      },
      {
        path: 'notificacoes',
        loadComponent: async () =>
          (await import('./pages/notificacoes/notificacoes.page'))
            .NotificacoesPage,
        canActivate: [AuthGuard, ForceChangePasswordGuard],
      },
      {
        path: 'minhas-assinaturas',
        loadComponent: async () =>
          (await import('./pages/minhas-assinaturas/minhas-assinaturas.page'))
            .MinhasAssinaturasPage,
        canActivate: [AuthGuard, ForceChangePasswordGuard],
      },
      {
        path: 'contratos',
        loadComponent: async () =>
          (await import('./pages/contratos/contratos.page')).ContratosPage,
        canActivate: [AuthGuard, ForceChangePasswordGuard],
      },
    ],
  },
];
